class Controller {
  constructor(Events, $injector, $stateParams, Sections) {
    "ngInject";

    this.page = $stateParams.page;
    this.limit = $stateParams.limit;

    this.Ticket = $injector.get("Ticket");
    this.TicketsTransforms = $injector.get("TicketsTransforms");
    this.paginateEvent = Events.getPaginateEvent("tickets");
    this.sections = Sections.settingsSections;
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/tickets/tickets.controller.js